var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4515_364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2013 19.4562C14.5578 19.0763 14.786 18.5941 14.8538 18.0775L18.7413 19.805C18.9315 19.8898 19.14 19.9257 19.3477 19.9094C19.5554 19.8931 19.7557 19.8252 19.9304 19.7118C20.1052 19.5984 20.2488 19.4431 20.3483 19.2601C20.4478 19.0771 20.4999 18.8721 20.5 18.6637V9.33625C20.4998 9.12809 20.4477 8.92328 20.3483 8.74039C20.2488 8.55751 20.1053 8.40234 19.9308 8.28898C19.7562 8.17561 19.5561 8.10764 19.3486 8.09123C19.141 8.07482 18.9327 8.11049 18.7425 8.195L14.8538 9.9225C14.7743 9.32136 14.4791 8.76958 14.0231 8.36991C13.5671 7.97024 12.9814 7.74993 12.375 7.75H5.84L14.2025 19.4562H14.2013ZM1.55875 8.20625C1.23153 8.43724 0.964566 8.74345 0.780322 9.0991C0.596079 9.45475 0.499942 9.84945 0.5 10.25V17.75C0.5 18.413 0.763392 19.0489 1.23223 19.5178C1.70107 19.9866 2.33696 20.25 3 20.25H10.16L1.55875 8.2075V8.20625ZM13.7413 23.1125L1.24125 5.6125L2.25875 4.8875L14.7587 22.3875L13.7413 23.1125Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#E76D7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7505 8.25047C15.7505 8.05168 15.8295 7.86103 15.97 7.72047C16.1106 7.57991 16.3012 7.50094 16.5 7.50094C16.6988 7.50094 16.8895 7.57991 17.03 7.72047C17.1706 7.86103 17.2496 8.05168 17.2496 8.25047C17.2496 8.44926 17.1706 8.6399 17.03 8.78047C16.8895 8.92103 16.6988 9 16.5 9C16.3012 9 16.1106 8.92103 15.97 8.78047C15.8295 8.6399 15.7505 8.44926 15.7505 8.25047ZM15.8247 3.74953C15.8147 3.65497 15.8247 3.55937 15.8541 3.46893C15.8834 3.37849 15.9315 3.29523 15.9951 3.22455C16.0587 3.15387 16.1364 3.09736 16.2233 3.05868C16.3102 3.01999 16.4042 3 16.4993 3C16.5944 3 16.6884 3.01999 16.7752 3.05868C16.8621 3.09736 16.9399 3.15387 17.0035 3.22455C17.0671 3.29523 17.1151 3.37849 17.1445 3.46893C17.1738 3.55937 17.1838 3.65497 17.1738 3.74953L16.9115 6.37814C16.9009 6.48005 16.8528 6.5744 16.7767 6.64298C16.7006 6.71156 16.6017 6.74951 16.4993 6.74951C16.3968 6.74951 16.298 6.71156 16.2218 6.64298C16.1457 6.5744 16.0977 6.48005 16.087 6.37814L15.8247 3.74953Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4515_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraNotFound);
export default __webpack_public_path__ + "static/media/cameraNotFound.49a76303160f5e02b5fb1cd5cecd16e1.svg";
export { ForwardRef as ReactComponent };